<template>
  <el-dialog
    :visible.sync="visible"
    :show-close="true"
    width="480px"
    custom-class="view-role-container"
    @close="handleClose"
  >
    <template #title>
      <div class="modal-title">{{ current.name || "角色信息" }}</div>
    </template>
    <div
      :class="[
        'role-content',
        { 'flex-center': current.type === 'pet' || !current.currentPotential || !current.currentPotential.length }
      ]"
    >
      <div :class="['icon', getItemBg(current)]">
        <img :src="current.cover_url" alt="" />
        <div
          v-if="
            current.currentStrengthen &&
              current.currentStrengthen.name &&
              strengthArr.includes(current.currentStrengthen.name)
          "
          class="strenth-icon"
        >
          <img :src="getStrenthUrl(current.currentStrengthen.name)" alt="" />
        </div>
        <div class="bottom-info">
          {{ current.currentSkin ? current.currentSkin.name : current.name }}
        </div>
      </div>
      <div v-if="current.currentPotential && current.currentPotential.length" class="des-box">
        <div v-for="item in current.currentPotential" :key="item.name" class="line">
          <img :src="item.icon" alt="" />
          <span v-if="item.desc" class="desc">{{ item.desc }}</span>
          <img v-if="!item.desc && item.image" :src="item.image" alt="" />
        </div>
      </div>
    </div>
    <template v-if="current.type === 'role'">
      <div v-if="current.currentStrengthen" class="info-box">
        <div class="left-skill">
          <div class="skill-title">范围</div>
          <img class="skill-img" :src="current.currentStrengthen.image" alt="" />
        </div>
        <div class="right-des">
          <div class="top-des">
            <span>SP: {{ current.currentStrengthen.sp }}</span>
            <span>CD: {{ current.currentStrengthen.cd }}</span>
          </div>
          <div class="des-content">
            {{ current.currentStrengthen.desc }}
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="info-box">
        <div class="left-skill">
          <div class="skill-title">范围</div>
          <img v-if="current.skill_image" class="skill-img" :src="current.skill_image" alt="" />
        </div>
        <div class="right-des">
          <div class="top-des">
            <span>{{ current.skill_name }}</span>
          </div>
          <div class="des-content">
            {{ current.skill_desc }}
          </div>
        </div>
      </div>
    </template>
  </el-dialog>
</template>
<script>
export default {
  props: {
    current: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      visible: false,
      strengthArr: ["+1", "+2", "+3", "+4", "+5", "满破满潜力"]
    };
  },
  watch: {
    visible: {
      handler(val) {
        console.log(val, this.current);
      }
    }
  },
  methods: {
    // 获取背景
    getItemBg(data) {
      if (data.attr === "火") {
        return "red";
      } else if (data.attr === "光") {
        return "yellow";
      } else if (data.attr === "水") {
        return "blue";
      } else if (data.attr === "暗") {
        return "purple";
      } else if (data.attr === "风") {
        return "green";
      }
      return "";
    },
    // 获取强化图标
    getStrenthUrl(name) {
      if (name === "满破满潜力") {
        return require(`@/assets/zs_imgs/battle/strenth_full.webp`);
      }
      return require(`@/assets/zs_imgs/battle/strenth${name}.webp`);
    },
    handleClose() {
      this.visible = false;
    }
  }
};
</script>
<style lang="less">
@import "./common.less";

.view-role-container {
  padding: 10px 16px 22px;
  .el-dialog__header {
    display: flex;
    align-items: center;
    margin-bottom: 14px;
    padding: 10px 0;
    color: #5a4434;
    font-size: 14px;
    font-weight: bold;
    border-bottom: 1px solid #e5e5e5;
  }
  .el-dialog__body {
    padding: 0;
    .role-content {
      display: flex;
      margin-bottom: 20px;
      &.flex-center {
        justify-content: center;
      }
      .icon {
        flex: 0 0 auto;
        position: relative;
        width: 98px;
        height: 128px;
        border-radius: 4px;
        .strenth-icon {
          position: absolute;
          right: 4px;
          top: 4px;
          width: 38px;
          height: 30px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        img {
          width: 100%;
          height: 100%;
          border-radius: 4px;
          object-fit: cover;
        }
        .bottom-info {
          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 24px;
          color: #fff;
          font-size: 12px;
          background-color: #665f5d;
        }
      }
      .des-box {
        display: flex;
        flex-direction: column;
        flex: 1;
        margin-left: 24px;
        .line {
          display: flex;
          align-items: center;
          height: 44px;
          border-bottom: 1px solid rgba(0, 0, 0, 0.08);
          &:last-child {
            border-bottom: none;
          }
          img {
            flex: 0 0 auto;
            width: 28px;
            height: 28px;
            margin-right: 10px;
          }
          .desc {
            flex: 1;
            color: #666666;
            font-size: 12px;
            font-weight: 400;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
    .info-box {
      display: flex;
      width: 100%;
      padding: 16px 25px;
      box-sizing: border-box;
      background-color: rgb(235, 231, 229, 0.42);
      border-radius: 8px;
      .left-skill {
        flex: 0 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 44px;
        .skill-title {
          margin-bottom: 23px;
          color: #5a4434;
          font-size: 14px;
          line-height: 21px;
          font-weight: 400;
        }
        img {
          width: 56px;
          height: 56px;
          object-fit: cover;
        }
      }
      .right-des {
        flex: 1;
        .top-des {
          display: flex;
          align-items: center;
          margin-bottom: 6px;
          span {
            margin-right: 30px;
            color: #ab5918;
            font-size: 14px;
            font-weight: 500;
            line-height: 21px;
            &:last-child {
              margin-right: 0;
            }
          }
        }
        .des-content {
          color: #666666;
          font-size: 12px;
          font-weight: 400;
        }
      }
    }
  }
}
</style>
